import {adminUserSlice} from "./slice";
export const {
    logout: adminUserLogout,
    increment: adminUserIncrement
} = adminUserSlice.actions;
